import { useEffect } from 'react';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import useSite from '~/client/hooks/useSite';
import useAccountPopoverStore from '~/client/store/useAccountPopoverStore';

const useRequestLoginEffect = () => {
  const { isBridgeSite } = useSite();
  const { showPopover, isDismissed, isDisplayed, activePopover } =
    useAccountPopoverStore();
  const { game } = useGameContext();
  const isLoggedIn = useIsLoggedIn();

  useEffect(() => {
    const isLoginRequired = shouldRequestLogin(
      game?.hasFunMode,
      isLoggedIn,
      isDisplayed,
    );
    if (isLoginRequired && !activePopover && !isDismissed && !isBridgeSite) {
      showPopover('login');
    }
  }, [
    game?.hasFunMode,
    isDismissed,
    isDisplayed,
    isLoggedIn,
    showPopover,
    activePopover,
    isBridgeSite,
  ]);
};

const shouldRequestLogin = (
  hasFunMode?: boolean,
  isLoggedIn?: boolean,
  isDisplayed?: boolean,
) => {
  if (!hasFunMode && !isLoggedIn) {
    return true;
  }
  return isDisplayed;
};

export default useRequestLoginEffect;
